/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ok2Inputs */

const en_ok2 = /** @type {(inputs: Ok2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const ar_ok2 = /** @type {(inputs: Ok2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`موافق`)
};

const de_ok2 = /** @type {(inputs: Ok2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const es_ok2 = /** @type {(inputs: Ok2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const fr_ok2 = /** @type {(inputs: Ok2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const it_ok2 = /** @type {(inputs: Ok2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const ja_ok2 = /** @type {(inputs: Ok2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const ko_ok2 = /** @type {(inputs: Ok2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`확인`)
};

const pt_br_ok2 = /** @type {(inputs: Ok2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const ru_ok2 = /** @type {(inputs: Ok2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Хорошо`)
};

const th_ok2 = /** @type {(inputs: Ok2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ตกลง`)
};

const tr_ok2 = /** @type {(inputs: Ok2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamam`)
};

const zh_cn_ok2 = /** @type {(inputs: Ok2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`好`)
};

const zh_tw_ok2 = /** @type {(inputs: Ok2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`好`)
};

/**
* | output |
* | --- |
* | "OK" |
*
* @param {Ok2Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
const ok2 = /** @type {((inputs?: Ok2Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ok2Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ok2(inputs)
	if (locale === "ar") return ar_ok2(inputs)
	if (locale === "de") return de_ok2(inputs)
	if (locale === "es") return es_ok2(inputs)
	if (locale === "fr") return fr_ok2(inputs)
	if (locale === "it") return it_ok2(inputs)
	if (locale === "ja") return ja_ok2(inputs)
	if (locale === "ko") return ko_ok2(inputs)
	if (locale === "pt_br") return pt_br_ok2(inputs)
	if (locale === "ru") return ru_ok2(inputs)
	if (locale === "th") return th_ok2(inputs)
	if (locale === "tr") return tr_ok2(inputs)
	if (locale === "zh_cn") return zh_cn_ok2(inputs)
	return zh_tw_ok2(inputs)
});
export { ok2 as "OK" }